<template>
	<el-main>
		<div class="content">

			<el-form :inline="true" class="demo-form-inline">
				<el-form-item label="审核时间">
					<el-date-picker v-model="approvestart" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker> 到
					<el-date-picker v-model="approveend" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="业务员:">
					<el-input v-model="txtQSalerName" placeholder="请输入业务员姓名"></el-input>
					企业：<el-select style=" width: 200px;  height:30px;" v-model="curcorpid" placeholder="请选择">
						<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id" >
							{{ item.corp_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="方案状态:">
					<el-select v-model="OState" placeholder="请选择">
						<!-- <el-option label="全部" value="-1" key="全部">全部</el-option> -->
						<el-option label="审核通过" value="2" key="审核通过">审核通过</el-option>
						<el-option label="可以体检" value="3" key="可以体检">可以体检</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="方案名称:">
					<el-input v-model="txtQOrderName" placeholder="请输入名称过滤" v-on:input='btnQOrderName'></el-input>

				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="btnQuery">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- <div class="contentview"> -->
		<!-- <div>
					<label class="center-text">方案名称</label>
					<label class="right-text">方案状态</label>
				</div> -->
		<!-- <div class="centerV"> -->
		<el-col class="el-col">
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<!-- <el-table-column prop="IsChecked" label="选择" width="50">
							<input type="checkbox" value="IsChecked" color="#FFCC33" style="float:left;transform:scale(0.7)" v-model='IsChecked'
							 v-bind:checked="IsChecked" @click="onCheckedChange(subIndex,$event)"></input>

						</el-table-column> -->
				<!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column prop="OrderName" label="方案名称" width="120px"></el-table-column>
				<!-- <el-table-column prop="OrderState" label="方案状态">
					<template slot-scope="scope">
						<label v-if='scope.row.OrderState=="0"'>创建方案</label>
						<label v-if='scope.row.OrderState=="1"'>提交方案</label>
						<label v-if='scope.row.OrderState=="2"'>审核通过</label>
						<label v-if='scope.row.OrderState=="3"'>可以体检</label>
					</template>
				</el-table-column> -->
				<el-table-column prop="Memo" label="备注" width="200px"></el-table-column>
				<el-table-column prop="SalerName" label="业务员"></el-table-column>
				<el-table-column prop="CommitDate" label="提交时间" width="100px"></el-table-column>
				<el-table-column prop="ApproveName" label="审核人"></el-table-column>
				<el-table-column prop="ApproveDate" label="审核时间" width="100px"></el-table-column>
				<el-table-column label="操作" width="260px">
					<template slot-scope="scope">
						<el-button @click="btnCanCheck(scope.$index, scope.row)" type="text" size="small">可以体检</el-button>
						<el-button @click="btnDownPerson(scope.$index, scope.row)" type="text" size="small">下载体检名单</el-button>
						<el-button @click="btnOrderReport(scope.row)" type="text" size="small">方案详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-col>
		<RouterView></RouterView>
	</el-main>
</template>
<script>
	//import Vue from 'vue'
	//import CommonFun from '../../commontools/CommonFun.js'
	import orderdata from '../../apifunction/Order.js'
	import corp from '../../apifunction/Corp.js'
	export default {
		created: function() {
			this.getAllCorp();
			// let user = JSON.parse(JSON.stringify(this.myglobal.userinfo));			
			// orderdata.GetOrderByJson(user.CorpID,this.approvestart,this.approveend,this.txtQSalerName,this.txtQOrderName,this.OState)
			// .then(res=>{
			// 		let ent = JSON.parse(JSON.stringify(res.data))
			// 		if (ent.Flag == 'success') {

			// 			this.listAll = JSON.parse(JSON.stringify(ent.Data));
			// 			this.lists = JSON.parse(JSON.stringify(this.listAll));


			// 		} else
			// 			this.$message.info(ent.Msg);
			// 	});
		},

		data() {
			return {
				CorpData: [],
				curcorpid: '',
				OState: '2',
				currentPage: 1,
				pagesize: 10,
				txtQOrderName: '',
				txtQSalerName: '',
				approvestart: this.CommonFun.GetNowDate(),
				approveend: this.CommonFun.GetNowDate(),
				lists: [],
				listAll: null,
				ShowPerson: false
			}
		},
		methods: {
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.CorpData = JSON.parse(ent.Data);


						} else
							this.$message.info(ent.Msg);
					})
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			btnQuery: function() {
				if (this.curcorpid == '') {
					this.$message.info('请选择查询企业！');
					return;
				}
				orderdata.GetOrderByJson(this.curcorpid, this.approvestart, this.approveend, this.txtQSalerName, this.txtQOrderName,
						this.OState)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							this.listAll = JSON.parse(ent.Data);
							this.lists = JSON.parse(JSON.stringify(this.listAll));


						} else
							this.$message.info(ent.Msg);
					})
			},
			btnQOrderName: function() {
				if (this.listAll == null)
					return;
				// this.$nextTick(function() {
				if (this.txtQOrderName == '') {
					this.lists = JSON.parse(JSON.stringify(this.listAll));
					// return
				} else {

					var templist = this.listAll.filter(item => {
						// alert(item.OrderName);
						// if (py.chineseToPY(item.OrderName).indexOf(py.chineseToPY(this.txtQOrderName)) > -1) 
						if (item.OrderName.indexOf(this.txtQOrderName) > -1) {
							return item
						}
					});
					this.lists = JSON.parse(JSON.stringify(templist));
				}

				// })
			},
			// 点击每一行
			didClickItem: function(item) {
				// this.$router.push()
				// uni.navigateTo({
				// 	url: '/pages/Order/Order_Edit' + '?ent=' + JSON.stringify(item)
				// });
			},
			btnOrderReport: function(item) {
				var data = {
					path: '/OrderReportQ',
					query: {
						ent: JSON.stringify(item)
					}
				};
				this.$router.push(data)
			},
			btnCanCheck: function(index, item) {
				if (item.OrderState == '2') {
					var entord = JSON.parse(JSON.stringify(item))
					entord.ApproveName = this.$myglobal.getUserInfo().username;
					entord.ApproveDate = CommonFun.GetNowDateTime();
					entord.OrderState = '3';
					//alert(JSON.stringify(entord))
					orderdata.CommitOrder(entord)
						.then(res => {
							//alert(JSON.stringify(res.data))
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.$message.info('保存成功！');
								item.ApproveName = entord.ApproveName;
								item.ApproveDate = entord.ApproveDate;
								item.OrderState = entord.OrderState;
								this.lists.splice(index, 1);
								var idx = this.listAll.findIndex(itm => {
									if (item.OrderID == itm.OrderID) {
										return true;
									}
								})

								this.listAll.splice(idx, 1);
							} else
								this.$message.info(ent.Msg);
						})
				} else
					this.$message.info('请选择‘审核通过’方案做此操作！')
			},
			btnDownPerson: function(index, item) {
				var p = {
					path: '/OrderPerson',
					query: {
						ent: JSON.stringify(item)
					}
				};
				this.$router.push(p) //replace
			}
		},
		computed: {
			data() {
				return this.lists;
			}
		},
		components: {
			// tableView
		}
	}
</script>
<style>
	page {
		background-color: rgb(241, 241, 241);
	}

	.colhead {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.content {
		margin-left: 10upx;
		margin-right: 10upx;
		margin-top: 10upx;
		/* max-height: 100upx; */
	}

	.contentview {
		overflow-y: scroll;
		max-height: 300px;
		background-color: #ECECEC;
		padding: 10px;
		margin: 10px;
		border-radius: 10px;
	}

	/* 最顶部内容 */
	.topV {
		background-color: #FFFFFF;
		height: 180upx;
		width: 100%;
	}

	.topV-img {
		margin-left: 30upx;
		margin-right: 10upx;
		width: 32upx;
		height: 32upx;
	}

	.topV-text {
		float: left;
		color: #FF9500;
		font-family: PingFang-SC-Medium;
		font-size: 28upx;
	}

	/* 中间内容 */
	.centerV {
		margin-top: 20upx;
	}

	/* 底部内容 */
	.bottomV {
		display: flex;
		flex-direction: column;
		margin-top: 30upx;
	}

	.left-text {
		/* background-color:  rgb(241, 241, 241); */
		float: left;
		font-family: PingFang-SC-Medium;
		font-size: 24upx;
		margin-right: 10upx;
	}

	.center-text {
		font-family: PingFang-SC-Medium;
		font-size: 24upx;
		color: #FF9500;
		float: center;
		/* max-width: 80upx;
		overflow: hidden; */
		/* min-width: 150upx; */
		/* width: 80upx;
		text-overflow: ellipsis; */
	}

	.right-text {
		font-family: PingFang-SC-Medium;
		font-size: 24upx;
		color: #3ABBFF;
		float: right;
	}

	.centerV-Item {
		background-color: #FFFFFF;
		margin-top: 10upx;
	}
</style>
